const MESSAGE_EVENT_TYPE = 'message',
  MAX_ERROR_ATTEMPTS = 5;

export { MESSAGE_EVENT_TYPE, MAX_ERROR_ATTEMPTS };
